let EscolaridadeData = {
    Titulo: 'Formação',
    sub: [
        {
            subtitulo: "Bacharelado em Engenharia de Software (cursando).",
            item: ["Universidade de Brasília, Faculdade de Gama."]
        },
        {
            subtitulo: "Ensino médio",
            item: ['Colégio Olimpo de Brasília.', "Colégio Único Educacional."]
        },
        
    ]

}

export default EscolaridadeData
